export function isDeepEqualIgnoringFields(a: any, b: any, ignoreKeys: string[] = []): boolean {
    const isObject = (obj: any) => obj && typeof obj === 'object';

    const clean = (obj: any): any => {
        if (!isObject(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(clean);

        return Object.keys(obj)
            .filter(key => !ignoreKeys.includes(key))
            .sort()
            .reduce((acc, key) => {
                acc[key] = clean(obj[key]);
                return acc;
            }, {} as any);
    };

    const cleanedA = clean(a);
    const cleanedB = clean(b);

    return JSON.stringify(cleanedA) === JSON.stringify(cleanedB);
}